import { createTheme } from "@mui/material/styles";

// ---------------- Theme (Avanse teal) ----------------
export const TEAL = "#0E9694";
export const TEAL_DARK = "#055858";
export const MINT_BG = "#E6F5F3";
export const YELLOW = "#F4C22C";
export const INK = "#0B4C4B";
export const MUTED = "#4A6867";

export const theme = createTheme({
  palette: {
    primary: { main: TEAL, dark: TEAL_DARK, contrastText: "#fff" },
    background: { default: MINT_BG },
    text: { primary: INK, secondary: MUTED },
  },
  typography: {
    fontFamily:
      'Jost',
    h1: { fontFamily: 'Jost', fontWeight: 700 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: TEAL,
            borderWidth: 1.5,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: TEAL_DARK,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: TEAL_DARK,
            borderWidth: 2,
          },
          "&.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d43a3a",
          },
        },
        input: { padding: "14px 16px", fontSize: 15, color: INK },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: MUTED,
          fontSize: 15,
          "&.Mui-focused": { color: TEAL_DARK },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          fontSize: 17,
          letterSpacing: 0.2,
        },
      },
    },
  },
});

// ---------------- Validators ----------------
export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const alphaNumRegex = /^[A-Za-z0-9]+$/;
